export default {
  left: [
    {
      id: 'shipFrom',
      showMultiple() {
        return false;
      },
    },
    {
      id: 'shipTo',
      showMultiple() {
        return false;
      },
    },
    {
      id: 'expectedDelivery',
      showMultiple() {
        return false;
      },
    },
    {
      id: 'confirmation',
      showMultiple() {
        return false;
      },
    },
    {
      id: 'insurance',
      showMultiple() {
        return false;
      },
    },
  ],
  right: [
    {
      id: 'dateShipped',
      showMultiple() {
        return false;
      },
    },
    {
      id: 'packageType',
      showMultiple(packageCount) {
        return packageCount > 1;
      },
    },
    {
      id: 'dimensions',
      showMultiple(packageCount) {
        return packageCount > 1;
      },
    },
    {
      id: 'weight',
      showMultiple(packageCount) {
        return packageCount > 1;
      },
    },
  ],
};
